import React from 'react';

const HourGlassIcon = (props: object) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15 15L7.875 9.65625C7.75857 9.56892 7.66406 9.45569 7.59897 9.32551C7.53389 9.19534 7.5 9.05179 7.5 8.90625V4.6875C7.5 4.43886 7.59877 4.2004 7.77459 4.02459C7.9504 3.84877 8.18886 3.75 8.4375 3.75H21.5625C21.8111 3.75 22.0496 3.84877 22.2254 4.02459C22.4012 4.2004 22.5 4.43886 22.5 4.6875V8.86406C22.4995 9.00862 22.4657 9.15111 22.401 9.2804C22.3364 9.40969 22.2427 9.52228 22.1273 9.60938L15 15Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 15L7.875 20.3438C7.75857 20.4311 7.66406 20.5443 7.59897 20.6745C7.53389 20.8047 7.5 20.9482 7.5 21.0938V25.3125C7.5 25.5611 7.59877 25.7996 7.77459 25.9754C7.9504 26.1512 8.18886 26.25 8.4375 26.25H21.5625C21.8111 26.25 22.0496 26.1512 22.2254 25.9754C22.4012 25.7996 22.5 25.5611 22.5 25.3125V21.1359C22.4999 20.991 22.4662 20.848 22.4016 20.7183C22.3369 20.5886 22.243 20.4756 22.1273 20.3883L15 15Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 21.5625H22.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HourGlassIcon;
